// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","mobile":"screen and (max-width: 600px)","container":"container-k61f5","wrapper":"wrapper-3FWIA","title":"title-3HPHn"};